<template>
	<div class="media-wrapper">
		<h1 class="vrnu-headline">Medien</h1>
		<div v-if="mediaElements.length > 0 && error == null">
			<b-button 	class="vrnu-button"
						v-on:click="openModal('addElementModal')"><span class="icon-plus-circled"></span>&nbsp;&nbsp;Mediendatei hinzufügen</b-button>
			<b-button 	v-if="selectedElements.length > 0"
						class="vrnu-button button-right"
						v-on:click="deleteMultipleImages"><span class="icon-trash"></span>&nbsp;&nbsp;<span v-if="selectedElements.length == 1">1 Ausgewähltes Element löschen</span><span v-else>{{ selectedElements.length }} ausgewählte Elemente löschen</span></b-button>
			<div class="media-container">
				<div class="space30"></div>
				<div 	v-for="(mediaElement, index) in mediaElements"
						v-bind:index="index"
						v-bind:id="mediaElement._id"
						v-bind:style="{backgroundImage: 'url(https://res.cloudinary.com/vrnu/image/upload/c_fill,h_200,w_200/v' + mediaElement.version + '/' + mediaElement.public_id + '.' + mediaElement.format + ')'}"
						v-bind:class="{mediaFrameSelected: selectedElements.includes(mediaElement._id)}"
						v-on:mouseenter="mousein"
						v-on:mouseleave="mouseout"
						class="media-frame">
					<div v-on:click="openPreviewElementModal(mediaElement._id)" v-if="hoverElement === mediaElement._id" class="media-frame-overlay"></div>
					<div v-if="hoverElement === mediaElement._id" class="media-frame-controls text-right">
						<a v-on:click="openDeleteImageModal(mediaElement._id)" class=""><span class="icon-trash"></span></a>
						<!-- <a v-on:click="toggleSelectElement(mediaElement._id)" class="check-element" v-bind:class="{elementSelected: selectedElements.includes(mediaElement._id)}"><span class="icon-check check-small" v-bind:class="{checkSelected: selectedElements.includes(mediaElement._id)}"></span></a> -->
					</div>
					<div v-else class="media-frame-controls text-right">
						<a v-if="selectedElements.includes(mediaElement._id)" class="check-element elementSelected"><span class="icon-check check-small checkSelected"></span></a>
					</div>
					<div v-on:click="openPreviewElementModal(mediaElement._id)" v-if="hoverElement === mediaElement._id" class="media-frame-preview text-center"><span class="icon-eye"></span></div>
				</div>
			</div>
		</div>
		<div v-if="error !== null">
			<b-alert show variant="danger">{{ error }}</b-alert>
		</div>
		<div v-if="mediaElements.length == 0 && error == null">
			<p class="text-center">
				In dieser Ansicht sind keine Elemente vorhanden.<br>Fügen Sie jetzt den ersten Eintrag hinzu!
				<br><br>
				<b-button 	v-on:click="openModal('addElementModal')"
							class="vrnu-button"><span class="icon-plus-circled"></span>&nbsp;&nbsp;Mediendatei hinzufügen</b-button>
			</p>
		</div>
		
		<!-- Form modal -->
		<b-modal ref="addElementModal" size="lg" centered hide-footer title="Datei hochladen">
			<p>Wählen Sie eine Datei aus, die Sie hinzufügen möchten oder ziehen Sie die Datei per Drag&Drop auf das Eingabefeld.</p>
			<b-form	v-on:submit.prevent="upload">
				<b-container class="no-padding">
					<b-row v-if="imageUrl !== null" no-gutters>
						<b-col no-gutters>
							<img 	v-bind:src="imageUrl"
									style="max-width: 100%;">
							<div class="space20"></div>
						</b-col>				
					</b-row>
					<b-row no-gutters>
						<b-col no-gutters>
							<b-form-group>
								<b-form-file
									id="image"
									ref="fileimage"
									placeholder="Bild hochladen"
									v-model.trim="image"
									v-bind:state="Boolean(image)"
									v-on:change="previewImage"
									accept="image/jpeg, image/png, image/gif">
								</b-form-file>
							</b-form-group>							
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-button v-if="image !== null" type="submit" class="vrnu-button">Hochladen</b-button>
							<b-button v-on:click="closeModal('addElementModal')">Abbrechen</b-button>
						</b-col>
					</b-row>
				</b-container>
			</b-form>
		</b-modal>	    
		
		<!-- Preview modal -->
		<b-modal ref="previewModal" size="lg" centered hide-footer title="Anzeige" v-on:hidden="previewElement = null">
			<b-img v-if="previewElement !== null" fluid-grow v-bind:src="previewElement.secure_url"></b-img>
		</b-modal>	    
		
		<!-- Info modal -->
		<b-modal ref="infoModal" centered hide-footer title="Info">
			<p>{{ infoModalMessage }}</p>
			<slot name="modal-ok">
				<b-button class="vrnu-button" v-on:click="$refs.infoModal.hide()">Ok</b-button>
			</slot>
	    </b-modal>	  
	    
	    <!-- Confirm modal -->
		<b-modal ref="confirmModal" centered hide-footer v-bind:title="'Bestätigen'">
			<p><span v-if="selectedElements.length <= 1">Wollen Sie dieses Element wirklich löschen?</span><span v-else>Wollen Sie diese Elemente wirklich löschen?</span></p>
			<slot name="modal-ok">
				<b-button class="vrnu-button" v-on:click="deleteImage(deleteElementId)">Ok</b-button>
			</slot>
			<slot name="modal-cancel">
				<b-button v-on:click="$refs.confirmModal.hide()">Abbrechen</b-button>
			</slot>
	    </b-modal>	    
	</div>
</template>

<script>
// Organize imports
export default {
	data: function() {
	    return {
	    	mediaElements: [],
	    	selectedElements: [],
	    	image: null,
	    	imageUrl: null,
	    	error: null,
	    	hoverElement: null,
	    	deleteElementId: null,
	    	previewElement: null,
	    	infoModalMessage: null,
	    	confirmModalMessage: null,
	    	showFileInputField: true,
	    };
	},
	computed: {
	},
	methods: {
		getImages: function() {
			// Get images from server
			this.$http.get('upload/image').then(images => {
				this.mediaElements = images.body;
			}, response => {
				this.error = "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
		},
		getImage: function(id) {
			// Get image from server
			this.$http.get('upload/image/' + id).then(image => {
				this.previewElement = image.body;
			}, response => {
				this.error = "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});			
		},
		deleteImage: function(id) {
			// Delete the image from the server
			this.$http.delete('upload/image/' + id).then(result => {
				// Check if the image may be in the selectedElements array and remove it if true
				if(this.selectedElements.includes(id)) {
					this.selectedElements.splice(this.selectedElements.indexOf(id), 1);
				}
				
				this.getImages();
				this.infoModalMessage = "Das Bild wurde erfolgreich gelöscht."
				this.openModal('infoModal');
			}, response => {
        if(response.status == 409) {
          this.getImages();
          // this.selectedElements = [];
          this.infoModalMessage = response.body.msg;
          this.openModal('infoModal');
        } else {
          this.error = "Beim Löschen des Bildes ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
        }
			});
		},
		deleteMultipleImages: function() {
			this.$http.post('upload/deleteMultipleImages', {images: this.selectedElements}).then(result => {
				this.getImages();
				this.selectedElements = [];
				this.infoModalMessage = "Die Bilder wurde erfolgreich gelöscht."
				this.openModal('infoModal');
			}, response => {
			  if(response.status == 409) {
          this.getImages();
          this.selectedElements = [];
          this.infoModalMessage = response.body.msg;
          this.openModal('infoModal');
        } else {
          this.error="Beim Löschen der Bilder ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
        }
			});
		},
		openModal: function(modalRef) {
			this.$refs[modalRef].show();
		},
		closeModal: function(modalRef) {
			this.$refs[modalRef].hide();
		},
		openDeleteImageModal: function(id) {
			this.deleteElementId = id;
			this.openModal('confirmModal');
		},
		mousein: function(e) {
			var hoverId = e.target.id;
			this.hoverElement = hoverId;
		},
		mouseout: function(e) {
			this.hoverElement = null;
		},
		previewImage(e) {
			const file = e.target.files[0];
			
			// Check if the image is a real file
			if(typeof file !== 'undefined') {
				this.imageUrl = URL.createObjectURL(file);	
			}
	    },
	    upload: function() {
			// Create a new FormData object
			var data = new FormData();
			data.append("image", this.image);

			// Save the image to the server
			this.$http.post('upload/image', data).then(result => {
				this.closeModal('addElementModal');
				this.image = null;
				this.imageUrl = null;
				this.$refs.fileimage.reset();
				this.getImages();
			}, response => {
				this.error="Beim Hochladen des Bildes ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
	    },
	    toggleSelectElement: function(id) {
	    	if(this.selectedElements.includes(id)) {
	    		this.selectedElements.splice(this.selectedElements.indexOf(id), 1);
	    	} else {
		    	this.selectedElements.push(id);	
	    	}
	    },
	    openPreviewElementModal: function(id) {
	    	// Get image from server and open the modal
	    	this.getImage(id);
	    	this.openModal('previewModal');
	    },
	},
	created: function() {
		this.getImages();
	},
	components: {
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.media-frame {
	display: inline-block;
	position: relative;
	
	margin: 0px 20px 20px 0px;
	width: 200px;
	height: 200px;
	
	border: 2px solid #ffffff;
	
	-webkit-box-shadow: 0px 0px 4px 0px rgba(89,89,89,1);
	-moz-box-shadow: 0px 0px 4px 0px rgba(89,89,89,1);
	box-shadow: 0px 0px 4px 0px rgba(89,89,89,1);
}
.media-frame:HOVER {
	cursor: pointer;
	
	-webkit-box-shadow: 0px 0px 5px 2px rgba(255,102,0,1);
	-moz-box-shadow: 0px 0px 5px 2px rgba(255,102,0,1);
	box-shadow: 0px 0px 5px 2px rgba(255,102,0,1);
}
.mediaFrameSelected {
	border: 2px solid #ff6600;
	
	-webkit-box-shadow: 0px 0px 5px 2px rgba(255,102,0,1);
	-moz-box-shadow: 0px 0px 5px 2px rgba(255,102,0,1);
	box-shadow: 0px 0px 5px 2px rgba(255,102,0,1);
}
.media-frame-overlay {
	position: relative;
	
	width: 200px;
	height: 200px;
	
	background-color: #ff6600;
	
	-ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)";
	filter: alpha(opacity=50);
	-moz-opacity: 0.5;
	-khtml-opacity: 0.5;
	opacity: 0.5;
}
.media-frame-preview {
	position: absolute;
	
	width: 50px;
	height: 50px;
	margin-left: -25px;
	margin-top: -38px;
	top: 50%;
	left: 50%;
	
	color: #ffffff;
	font-size: 50px;
}
.media-frame-controls {
	position: absolute;
	
	width: 100%;
	height: 50px;
	padding: 7px 10px 0px 0px;
	
	top: 0;
	left: 0;
	
	color: #ffffff;
}
.check-element {
	display: inline-block;
	float: both;
	width: 18px;
	height: 18px;
	margin-top: -3px;
	margin-left: 5px;
	
	text-align: center;
	vertical-align: middle;
	
	border: 1px solid #ffffff;
	border-radius: 20px;
	
}
.elementSelected {
	background-color: #ffffff;
}
.check-small {
	display: inline-block;
	position: relative;
	
	top: -7px;
	
	font-size: 13px;
}
.checkSelected {
	color: #ff6600;
}
</style>



// WEBPACK FOOTER //
// src/components/06_media/Media.vue